import React, { useState } from "react";
import { AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";
import { formatMoney, formatMoney2, formatNumber } from "../lib/api";
import { ExportButtons } from "../lib/exports";

const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");
const COLS = [
  { header: "CN", key: "cn" }, { header: "Descripción", key: "descripcion" }, { header: "Familia", key: "familia" },
  { header: "Stock", key: "stock", align: "right" }, { header: "Valor PVP (€)", key: "valor_pvp", format: (v) => (v || 0).toFixed(2), align: "right" },
  { header: "Última entrada", key: "u_entrada", format: fecha }, { header: "Última venta", key: "u_salida", format: fecha },
];

export function AvisoStockAntiguo({ a, lab }) {
  const [abierto, setAbierto] = useState(false);
  if (!a || !a.refs) return null;
  return (
    <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4 mb-4" data-testid="aviso-stock-antiguo">
      <div className="flex items-start gap-3 flex-wrap">
        <AlertTriangle className="text-red-600 shrink-0 mt-0.5" size={20} />
        <div className="flex-1 min-w-[220px]">
          <div className="font-bold text-red-800">Stock antiguo sin movimiento</div>
          <div className="text-sm text-red-900 mt-0.5" data-testid="aviso-stock-antiguo-texto">
            <b>{formatNumber(a.refs)}</b> producto{a.refs === 1 ? "" : "s"} con <b>{formatNumber(a.uds)} uds</b> y <b>{formatMoney(a.eur)}</b> a PVP
            entraron antes del {fecha(a.desde)} (hace más de 2 años) y no se han vendido desde entonces.
          </div>
        </div>
        <button onClick={() => setAbierto((v) => !v)} className="btn btn-outline btn-sm bg-white" data-testid="aviso-stock-antiguo-ver">
          {abierto ? <ChevronUp size={14} /> : <ChevronDown size={14} />} {abierto ? "Ocultar" : "Ver productos"}
        </button>
      </div>
      {abierto && (
        <div className="mt-3 bg-white rounded-lg border border-red-200">
          <div className="flex justify-end p-2">
            <ExportButtons filename="stock-antiguo-sin-movimiento" title={`Stock antiguo sin movimiento · ${lab}`} sheetName="Stock antiguo"
                           columns={COLS} rows={a.items} testIdPrefix="aviso-stock-antiguo-export" />
          </div>
          <div className="overflow-auto max-h-80">
            <table className="dense" data-testid="aviso-stock-antiguo-tabla">
              <thead><tr><th>CN</th><th>Descripción</th><th>Familia</th><th className="num">Stock</th><th className="num">Valor PVP</th><th>Última entrada</th><th>Última venta</th></tr></thead>
              <tbody>
                {a.items.map((p) => (
                  <tr key={p.cn} data-testid={`aviso-stock-antiguo-fila-${p.cn}`}>
                    <td className="font-mono text-xs">{p.cn}</td><td className="text-xs">{p.descripcion}</td>
                    <td className="text-xs text-slate-500">{p.familia}</td><td className="num">{formatNumber(p.stock)}</td>
                    <td className="num font-semibold text-red-700">{formatMoney2(p.valor_pvp)}</td>
                    <td className="whitespace-nowrap">{fecha(p.u_entrada)}</td><td className="whitespace-nowrap">{fecha(p.u_salida)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {a.refs > a.items.length && <p className="text-xs text-slate-500 p-2">Se muestran los {a.items.length} de más valor de {formatNumber(a.refs)}.</p>}
        </div>
      )}
    </div>
  );
}
